import type { TagKey } from "@/mocks/chiguaData";
import { tagMap } from "@/mocks/chiguaData";

interface TagBadgeProps {
  tag: TagKey;
}

export default function TagBadge({ tag }: TagBadgeProps) {
  const cls = tagMap[tag];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${cls}`}
    >
      <i className="ri-sparkling-2-fill text-[10px]" aria-hidden="true"></i>
      {tag}
    </span>
  );
}